declare global {
  interface Window {
    adconsent: (
      arg0: string,
      arg1?: any,
      arg2?: (consent: any, success: any) => any
    ) => void
    __tcfapi: (
      arg0: string,
      arg1: number,
      arg2: (tcData: any, success: any) => void
    ) => void
    snigelPubConf: {
      adengine: {
        activeAdUnits: string[]
      }
    }
    gtag?: any
    dataLayer?: any[]
  }
}

/**
 * Loads ad script and sets active ad units.
 * For Premium users ad script needs to be loaded so we can get consent, but active units should be empty so no ads appear.
 * For non premium users, ad script needs to be loaded with correct active ad units.
 */
export const loadAdScript = (isPremium: boolean) => {
  // set active ad units
  setActiveAdUnits(isPremium)

  // load ad script
  const href = window.location.href
  let src = ''
  if (
    href.includes('staging') ||
    href.includes('auth') ||
    href.includes('localhost') ||
    href.includes('.pages.dev')
  ) {
    console.log('Loading STAGING ads script')
    src = 'https://staging-cdn.snigelweb.com/adengine/searchle.net/loader.js'
  } else if (href.includes('searchle.net')) {
    console.log('Loading LIVE ads script')
    src = 'https://cdn.snigelweb.com/adengine/searchle.net/loader.js'
  }

  const node = document.createElement('script')
  node.src = src
  node.type = 'text/javascript'
  node.async = true
  node.setAttribute('data-cfasync', 'false')

  if (
    !document.querySelector(`script[src*="adengine/searchle.net/loader.js"]`)
  ) {
    document.getElementsByTagName('head')[0].appendChild(node)
  }
}

function getActiveAdUnits() {
  let breakpoint = 'xsmall'

  const w = window.innerWidth

  breakpoint = w >= 768 ? 'small' : breakpoint
  breakpoint = w >= 1150 ? 'medium' : breakpoint
  breakpoint = w >= 1280 ? 'large' : breakpoint
  breakpoint = w >= 1400 ? 'xlarge' : breakpoint

  let activeUnits = []

  switch (breakpoint.toLowerCase()) {
    case 'xsmall': // Small Mobile
      activeUnits = ['adhesion', 'top_banner'] // Mobile Ad Units
      break
    case 'small': // Portrait Tablet / Large Mobile
      activeUnits = ['adhesion', 'top_banner'] // Mobile Ad Units
      break
    default:
    case 'medium':
    case 'xlarge':
    case 'large':
      activeUnits = ['sidebar_left', 'sidebar_bottom', 'video', 'adhesion']
      break
  }

  window.snigelPubConf = {
    adengine: {
      activeAdUnits: activeUnits,
    },
  }
  return activeUnits
}

function setActiveAdUnits(isPremium: boolean) {
  if (isPremium) {
    window.snigelPubConf = {
      adengine: {
        activeAdUnits: [''],
      },
    }
    return
  }

  const activeUnits = getActiveAdUnits()

  window.snigelPubConf = {
    adengine: {
      activeAdUnits: activeUnits,
    },
  }
}

/**
 * Check for consent through Snigel, then set GA consent
 */
export const checkForConsent = () => {
  window.addEventListener('adnginLoaderReady', function () {
    window.adconsent &&
      window.adconsent('getConsent', null, function (consent, success) {
        if (success) {
          if (consent.fullConsent) {
            console.log('########### yas consent')
            window.gtag('consent', 'update', {
              ad_storage: 'granted',
              analytics_storage: 'granted',
              ad_user_data: 'granted',
              ad_personalization: 'granted',
            })
          } else {
            console.log('########### naur consent')
            clearAnalyticsCookies()
          }
        }
      })
  })
}

function clearAnalyticsCookies(): void {
  const teuteufCookieNames = ['_gid']

  // delete all _ga cookies
  document.cookie
    .split(';')
    .map((c) => c.trim())
    .forEach((cookie) => {
      const name = cookie.split('=')[0]
      if (name.startsWith('_ga')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.searchle.net`
      }
    })

  // delete other analytics cookies
  teuteufCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.searchle.net`
  })
}
